import { render, staticRenderFns } from "./CarouselStacked.vue?vue&type=template&id=7532aca5"
import script from "./CarouselStacked.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselStacked.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports